<template>
  <div class="team-member" :class="classes">
    <div class="team-member__index">{{ index }}.</div>
    <div class="team-member__name">{{ name }}</div>
    <template v-if="!disabled">
      <AppBtn
        v-if="!member"
        class="team-member__btn-add"
        @click="openMemberModal"
      >
        Добавить участника
      </AppBtn>
      <button
        v-else-if="$core.breakpoint.mdAndUp"
        class="team-member__edit"
        @click="openMemberModal"
        title="Редактировать"
      >
        <svg-icon icon-name="list" size="28"></svg-icon>
      </button>
      <AppBtn
        v-else
        class="team-member__btn-add"
        @click="openMemberModal"
        color="third"
      >
        Редактировать
      </AppBtn>
    </template>
  </div>
</template>

<script>
import { openModal as openMemberModal } from "./TeamMemberEdit";

export default {
  name: "TeamViewRosterMember",
  props: {
    disabled: Boolean,
    member: Object,
    index: Number
  },
  computed: {
    classes() {
      return {
        "team-member_full": !!this.member,
        "team-member_empty": !this.member
      };
    },
    name() {
      const { member } = this;
      return member
        ? `${member.first_name} ${member.last_name}`
        : "Участник отсутствует";
    }
  },
  methods: {
    openMemberModal() {
      openMemberModal(this.member);
    }
  }
};
</script>

<style lang="scss">
$p: ".team-member";

.team-member {
  height: 60px;
  display: flex;
  color: colors(text-3);
  align-items: center;
  padding: 5px 5px 5px 20px;
  font-size: 18px;
  border-radius: 4px;
  color: colors(text-2);
  background-color: colors(palette-6);
  font-size: 20px;
  font-weight: fw(bold);

  &__index {
    width: 70px;
    flex-shrink: 0;
  }

  &__btn-add {
    width: 270px;
    height: 100%;
    flex-shrink: 0;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: fw(bold);
  }

  &__edit {
    width: 50px;
    height: 100%;
    flex-shrink: 0;
    color: colors(text-3);
    transition: transform 0.2s;
    &:hover {
      transform: scale(1.05);
    }
    &:active {
      transform: scale(0.95);
    }
  }

  &__name {
    margin-right: auto;
    padding-right: 10px;
    @include text-ellipsis();
    text-transform: uppercase;
  }

  &_full {
    background-color: colors(palette-2);
    color: colors(text-3);
  }

  @include breakpoint("sm-and-down") {
    flex-direction: column;
    height: auto;
    padding: 15px;
    align-items: flex-start;
    position: relative;
    font-size: 18px;

    &__btn-add {
      height: 45px;
      width: 100%;
    }
    &__name {
      margin: 15px 0;
      max-width: 100%;
      padding-right: 0;
    }
  }
}
</style>
